/* eslint-disable yoda */
import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';

const UploaderPageContext = createContext(null);

export function UploaderPageProvider ({ params, intl, router, isMobile, children }) {
  const { spaceId, listingId } = params;
  const isListing = !!listingId;

  const value = {
    intl,
    spaceId,
    listingId,
    isListing,
    router,
    isMobile
  };

  return (
    <UploaderPageContext.Provider value={value}>
      {children}
    </UploaderPageContext.Provider>
  );
}

UploaderPageProvider.propTypes = {
  params: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  isMobile: PropTypes.bool.isRequired,
  children: PropTypes.node
};

/**
 * Custom hook to consume page context data.
 */
export function useUploaderPageData () {
  const context = useContext(UploaderPageContext);
  if (context === null) {
    throw new Error('useUploaderPageData must be used within an UploaderPageProvider.');
  }
  return context;
}
